import styled, { css } from 'styled-components'

export const swatchItem = css`
  cursor: pointer;
  outline: none !important;
  background: ${props => props.theme.palette.general.light};
  border: 0;
  margin: 0;
  transition: all ease-in-out 0.3s;
  border-radius: 4px;
  box-shadow: 0 0 0 1px ${props => props.theme.palette.general.strong};
  padding: 2px;

  span {
    width: 40px;
    height: 40px;
    display: block;
    border-radius: 4px;
  }

  &:hover {
    opacity: 0.7;
  }

  &.active {
    cursor: default;
    box-shadow: 0 0 0 1px ${props => props.theme.palette.general.grey};

    &:hover {
      opacity: 1;
    }
  }

  &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const Container = styled.div`
  display: inline-block;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: center;
  }

  li {
    margin: 0 6px;
    display: flex;
    align-items: center;
  }

  small {
    font-size: 12px;
    color: ${props => props.theme.palette.general.greyDark};
    margin: 0 0 0 5px;
  }

  button {
    ${swatchItem};

    > span {
      height: 22px;
      width: 22px;
      font-size: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;
      color: ${props => props.theme.palette.general.strong};
    }
  }
`
